import { MdOutlineKeyboardArrowLeft, MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { useLocation, useNavigate } from 'react-router-dom';

const BtnPageContainer = ({ pageAds, setPageAds, setCurrPage }) => {
  const { numOfPages, currentPage } = pageAds;

  const { search, pathname } = useLocation();
  const navigate = useNavigate();

  const handlePageNumber = (page) => {
    setPageAds({ ...pageAds, currentPage: page });
    setCurrPage(page);
    const searchParams = new URLSearchParams(search);
    searchParams.set('page', page);
    const newUrl = `${pathname}?${searchParams.toString()}`;

    navigate(newUrl, { state: { hash: 'search' } });
  };

  const addPageButton = ({ page, activeClass }) => {
    return (
      <button
        key={Math.floor(Math.random() * 100000)}
        className={`h-8  w-8 rounded-full  ${activeClass && 'bg-primary-yellow'}`}
        onClick={() => {
          handlePageNumber(page);
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }}
      >
        {page}
      </button>
    );
  };

  const renderPageButtons = () => {
    const pageButtons = [];
    //firstButton
    pageButtons.push(addPageButton({ page: 1, activeClass: currentPage === 1 }));
    //dotsBefore
    if (currentPage > 3) {
      pageButtons.push(
        <span key={'dots1'} className='pb-2  text-center sm:w-8'>
          ...
        </span>
      );
    }
    //beforeCurrentButton
    if (currentPage !== 1 && currentPage !== 2) {
      pageButtons.push(addPageButton({ page: currentPage - 1, activeClass: false }));
    }
    //currentButton
    if (currentPage !== 1 && currentPage !== numOfPages) {
      pageButtons.push(addPageButton({ page: currentPage, activeClass: true }));
    }
    //afterCurrentButton
    if (currentPage !== numOfPages && currentPage !== numOfPages - 1) {
      pageButtons.push(addPageButton({ page: currentPage + 1, activeClass: false }));
    }
    //dotsAfter
    if (currentPage < numOfPages - 2) {
      pageButtons.push(
        <span key={'dots2'} className='pb-2 text-center sm:w-8'>
          ...
        </span>
      );
    }
    //lastButton
    pageButtons.push(addPageButton({ page: numOfPages, activeClass: currentPage === numOfPages }));

    return pageButtons;
  };

  return numOfPages > 1 ? (
    <div className='flex justify-between gap-3.5'>
      {currentPage !== 1 ? (
        <button
          className='grid h-9 w-9 place-items-center rounded-full bg-[#EDEDED]'
          onClick={() => {
            let prevPage = currentPage - 1;
            if (prevPage < 1) prevPage = 1;
            handlePageNumber(prevPage);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        >
          <MdOutlineKeyboardArrowLeft />
        </button>
      ) : null}
      <div
        className={`flex w-44 rounded-2xl bg-[#EDEDED] 
        ${numOfPages < 3 ? 'justify-center' : 'justify-between'} 
         items-center px-1 sm:w-52`}
      >
        {renderPageButtons()}
      </div>
      {currentPage !== numOfPages ? (
        <button
          className='grid h-9 w-9 place-items-center rounded-full bg-[#EDEDED]'
          onClick={() => {
            let nextPage = currentPage + 1;
            if (nextPage > numOfPages) nextPage = numOfPages;
            handlePageNumber(nextPage);
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
        >
          <MdOutlineKeyboardArrowRight />
        </button>
      ) : null}
    </div>
  ) : null;
};

export default BtnPageContainer;
